// The `definedVariables` folder contains markdown variables implementations that can be shared across different projects.
export * from './EngageLetterVariables'
